import React from 'react';
interface MobileFrameProps {
  children: ReactNode;
}
const MobileFrame: React.FC<MobileFrameProps> = ({
  children
}) => {
  return <div className="relative w-full max-w-[375px] h-[812px] bg-[#002B36] rounded-[40px] overflow-hidden shadow-2xl border-8 border-gray-800" data-id="element-17">
      {/* Notch */}
      <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-1/2 h-7 bg-gray-800 rounded-b-2xl z-50" data-id="element-18"></div>
      {/* Screen Content */}
      <div className="relative w-full h-full overflow-y-auto scrollbar-hide" data-id="element-19">
        {children}
      </div>
    </div>;
};
export default MobileFrame;